(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (reduceMotion.matches) {
    return;
  }

  const amountValue = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue('--croma-editorial-parallax-amount')
    .trim();
  const amount = Number.parseFloat(amountValue) || 0;

  if (amount <= 0) {
    return;
  }

  let layers = [];
  let ticking = false;

  const refreshLayers = () => {
    const scale = 1 + Math.min(amount, 160) / 1000;

    layers = Array.from(document.querySelectorAll('[data-croma-editorial-parallax]')).map((layer) => ({
      layer,
      source: layer.closest('.croma-section') || layer.parentElement || layer,
    }));

    layers.forEach(({ layer }) => {
      layer.style.setProperty('--croma-editorial-parallax-scale', scale.toFixed(3));
    });

    requestUpdate();
  };

  const updateLayers = () => {
    ticking = false;

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    // Read geometry for every layer before writing styles: avoid layout thrashing.
    const updates = layers.map(({ layer, source }) => {
      const rect = source.getBoundingClientRect();

      if (rect.bottom < 0 || rect.top > viewportHeight) {
        return null;
      }

      const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
      const offset = (progress - 0.5) * amount * -1;

      return { layer, offset: `${offset.toFixed(2)}px` };
    });

    updates.forEach((update) => {
      if (!update) return;
      const { layer, offset } = update;
      if (layer.style.getPropertyValue('--croma-editorial-parallax-offset') !== offset) {
        layer.style.setProperty('--croma-editorial-parallax-offset', offset);
      }
    });
  };

  const requestUpdate = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(updateLayers);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('shopify:section:load', refreshLayers);
  document.addEventListener('shopify:section:unload', refreshLayers);

  refreshLayers();
})();
